import { FrameListDownloads } from '@Modules/Downloads';
import { type RouteObject } from 'react-router';

// @ai-generated 2026-09-25T11:00:00+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function setupDownloadRouting(): RouteObject {
    return {
        path: 'downloads',
        element: <FrameListDownloads />,
    };
}
